import React from "react";

// Components
import Category from "components/Docs/DocsMenu/Category/Category";
import Item from "components/Docs/DocsMenu/Item/Item";

// Data
import fileTree from "documentation/config/help/fileTree";

// Styles
import HelpContainer from "./Help.styles";
import FileTree from "../../../../Common/FileTree/FileTree";

export default function Help() {
    return (
        <HelpContainer className={"submenu"}>
            <div className={"top"}>
                <h1>HELP</h1>
                <hr />

                <div className="menu">
                    <FileTree tree={fileTree} />
                </div>
            </div>

            <div className={"bottom"}></div>
        </HelpContainer>
    );
}
